import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import { truncate } from 'flarum/common/utils/string';
import truncateHtml from '../utils/truncateHtml';
export default class Excerpt extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "post", void 0);
    _defineProperty(this, "length", void 0);
    _defineProperty(this, "richExcerpt", void 0);
    _defineProperty(this, "mediaMaxHeight", void 0);
    _defineProperty(this, "videoMaxWidth", void 0);
    _defineProperty(this, "mediaCount", void 0);
    _defineProperty(this, "cachedHtml", null);
    _defineProperty(this, "cacheKey", '');
  }
  oninit(vnode) {
    var _this$attrs$mediaMaxH, _this$attrs$videoMaxW, _this$attrs$mediaCoun;
    super.oninit(vnode);
    this.post = this.attrs.post;
    this.length = this.attrs.length;
    this.richExcerpt = this.attrs.richExcerpt;
    this.mediaMaxHeight = (_this$attrs$mediaMaxH = this.attrs.mediaMaxHeight) != null ? _this$attrs$mediaMaxH : 200;
    this.videoMaxWidth = (_this$attrs$videoMaxW = this.attrs.videoMaxWidth) != null ? _this$attrs$videoMaxW : 320;
    this.mediaCount = (_this$attrs$mediaCoun = this.attrs.mediaCount) != null ? _this$attrs$mediaCoun : 1;
  }
  view() {
    const style = {};
    if (this.richExcerpt && this.mediaMaxHeight > 0) {
      style['--synopsis-media-max-height'] = this.mediaMaxHeight + 'px';
      style['--synopsis-video-max-width'] = this.videoMaxWidth + 'px';
    }
    return m("div", {
      className: "Synopsis-excerpt",
      style: style
    }, this.getContent());
  }
  getContent() {
    var _this$post$contentPla;
    if (this.richExcerpt) {
      var _this$post$contentHtm;
      const contentHtml = (_this$post$contentHtm = this.post.contentHtml()) != null ? _this$post$contentHtm : '';
      const key = "".concat(contentHtml, "|").concat(this.length, "|").concat(this.mediaMaxHeight, "|").concat(this.mediaCount);
      if (this.cachedHtml !== null && this.cacheKey === key) {
        return m.trust(this.cachedHtml);
      }
      this.cachedHtml = truncateHtml(contentHtml, this.length, this.mediaMaxHeight, this.mediaCount);
      this.cacheKey = key;
      return m.trust(this.cachedHtml);
    }
    return truncate((_this$post$contentPla = this.post.contentPlain()) != null ? _this$post$contentPla : '', this.length);
  }
}
flarum.reg.add('lcoy-synopsis', 'forum/components/Excerpt', Excerpt);